module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-2-b256b0b87ffcca7ee6084fcdea2a8a3d.png";